import React from "react";
import logo from "../Images/brand/logo.png"

import Header_home from "../Components/Partials/Header_home"

function NotFound(){
    return <section >
                <Header_home />
                <main className="flex flex-col items-center flex-auto px-5 py-40 pt-5 mt-20">
                        <svg className="mb-4 animate-pulse" width="97" height="106" viewBox="0 0 97 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="65" height="106" fill="url(#paint0_linear_116_164)" />
                            <rect x="32" width="65" height="106" fill="url(#paint1_linear_116_164)" />
                            <defs>
                                <linearGradient id="paint0_linear_116_164" x1="32.5" y1="0" x2="32.5" y2="106" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#D9D9D9" stopOpacity="0" />
                                    <stop offset="1" stopColor="#9900FF" />
                                </linearGradient>
                                <linearGradient id="paint1_linear_116_164" x1="64.5" y1="0" x2="64.5" y2="106" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#9900FF" />
                                    <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
                                </linearGradient>
                            </defs>
                        </svg>

                        <h1 className="text-center text-7xl animate__animated animate__fadeInUp animate__delay-1s">ERROR</h1>
                        <blockquote>
                            <p className="text-xl text-center text-slate-500 animate__animated animate__fadeInUp animate__delay-2s">
                            When you invent the ship, you also invent the shipwreck;<br /> when you invent the plane you also invent the plane crash;<br /> and
                            when you invent electricity, you invent electrocution…<br /> Every technology carries its own negativity, which is invented at
                            the same time as technical progress.</p>
                        </blockquote>
                        <cite>
                            <p className="text-xl text-center text-slate-600 animate__animated animate__fadeInUp animate__delay-3s">Paul Virilio</p>
                        </cite>
                        <a className="flex mt-10 cta cta-primary animate__animated animate__fadeInUp animate__delay-2s" href="/">Back to home</a>
                </main>     
    </section>
}

export default NotFound;